/*@ngInject*/
const AssignAccountRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.assignAccount = function (submissionId, accountId, accountNumber) {
        let url = '/rest/Account/assignSubmission',
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                params: {
                    accountId: accountId,
                    accountNumber: accountNumber,
                    submissionId: submissionId
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('assignAccountRepository', AssignAccountRepository);
